import {useState, useRef, useCallback} from 'react'
import {selectors as usersSelectors, actions as usersActions} from "../../../../Ducks/users";
import {selectors as accountSelectors} from '../../../../Ducks/account';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {cloneDeep, isEmpty} from 'lodash';
import CustomGridElement from './CustomGridElement';
import {
    getVisibleColumns,
    prepareFilterQuery,
    prepareSortQuery,
} from "../../../Utils/gridUtils";
import {getUsers} from "../../../../API/users";
import {updateUserSetting} from "../../../../API/userSettings";
import {getUserSettings} from "../../../Utils/constants";

const isDateColumn = (key) => {
    return (key === 'user_deactivated')
}

const isColumnFilterable = (key) => {
    return (key !== "teams.team_name");
}

const TeamUsersGrid = (props) => {
    const {navigate, team, usersState} = props;
    const {user, userMeta} = getUserSettings();
    const lastSortBy = user?.tableSettings?.teams?.sortBy ? user.tableSettings.teams.sortBy : null;

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [rowsCount, setRowsCount] = useState(0);
    const [filters, setFilters] = useState(() => {
        return user?.tableSettings?.teams?.filters ? user.tableSettings.teams.filters : [];
    });
    const [controlledPageIndex, setControlledPageIndex] = useState(0);
    const [cols, setCols] = useState(() => {
        let columns = userMeta.table_columns.users;
        let visibleColumns = user.tableSettings.teams?.columns ? user.tableSettings.teams?.columns : [];
        let invisibleColumns = columns.filter((column) => !visibleColumns.includes(column));
        columns = [...visibleColumns, ...invisibleColumns];

        return getVisibleColumns(columns, visibleColumns, isDateColumn, isColumnFilterable);
    });
    const fetchIdRef = useRef(0);
    const fetchData = useCallback(({pageSize, pageIndex, sortBy, filters, columns, team, usersState}) => {
        // This will get called when the table needs new data
        // You could fetch your data from literally anywhere,
        // even a server. But for this example, we'll just fake it.

        // Parse columns
        const _columns = columns.map((item) => item.column)

        // Give this fetch an ID
        const fetchId = ++fetchIdRef.current

        // Set the loading state
        setLoading(true);

        const query = prepareFilterQuery(filters, columns) + `&equals[teams.team_id]=${team}${usersState}`;
        const sort = prepareSortQuery(sortBy, columns);

        getUsers({
            results: pageSize,
            columns: _columns,
            offset: pageIndex + 1,
            filter: query,
            sort: sort,
        }).then(users => {
            if (fetchId === fetchIdRef.current && users) {
                const _users = cloneDeep(users);
                const teams = users.data.related_objects["teams"]
                const countries = users.data.related_objects["countries"]

                if (!isEmpty(users.data.related_objects)) {
                    _users.data.main.forEach((user, _index) => {
                        if (teams && !isEmpty(teams[user.team_id])) {
                            const _team_obj = cloneDeep(teams[user.team_id])
                            delete _team_obj["team_id"]
                            Object.assign(user, _team_obj);
                        }
                        if (countries && !isEmpty(countries[user.country_id])) {
                            const _country_obj = cloneDeep(countries[user.country_id])
                            delete _country_obj["country_id"]
                            Object.assign(user, _country_obj);
                        }
                    });
                }

                setData(_users.data.main);
                setPageCount(users.data.offset.highest_offset);
                setRowsCount(users.data.offset.rows_count);

                const user = JSON.parse(localStorage.getItem("user"));
                updateUserSetting(user).then(() => {
                    setLoading(false);
                });
            }
        }).catch((error) => {
            setLoading(false);
            return error
        });
    }, []);

    const resetFilters = useCallback(() => setFilters([]), [setFilters]);

    const handleRowClick = (row) => {
        navigate("/user/id/" + row.original.user_id);
    }

    return (
        <>
            <CustomGridElement
                team={team}
                usersState={usersState}
                columns={cols}
                data={data}
                fetchData={fetchData}
                loading={loading}
                pageCount={pageCount}
                controlledPageIndex={controlledPageIndex}
                setControlledPageIndex={setControlledPageIndex}
                filters={filters}
                setFilters={setFilters}
                resetFilters={resetFilters}
                rowsCount={rowsCount}
                handleRowClick={handleRowClick}
                initialSortBy="user_id"
                showColumnsControl={true}
                showCsvDownloadControl={true}
                setColumns={setCols}
                table="teams"
                lastSortBy={lastSortBy}
            />
        </>
    )
}

const mapStateToProps = (state) => ({
    isLoading: usersSelectors.isLoading(state),
    usersList: usersSelectors.usersList(state),
    user: accountSelectors.user(state),
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getUsersList: usersActions.getUsersList
        },
        dispatch
    );

function WithNavigate(props) {
    let navigate = useNavigate();
    return <TeamUsersGrid {...props} navigate={navigate}/>
}

export default connect(mapStateToProps, mapDispatchToProps)(WithNavigate);